import { Button, Chip, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ButtonSwitchContainer = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "flex-start",
    alignSelf: "stretch",
    gap: "0.0625rem",
    borderRadius: '0.5rem'
}));

export const CustomButton = styled(Button)(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "0.5rem",
    flex: "1 0 0",

    padding: `${theme.space._300} ${theme.space._450}`,

    cursor: "pointer",
    transition: "all 300ms ease-in-out",
    backgroundSize: "200% auto",

    '&.left': {
        borderRadius: '0.5rem 0rem 0rem 0.5rem',
    },

    '&.middle': {
        borderRadius: '0rem',
    },

    '&.right': {
        borderRadius: '0rem 0.5rem 0.5rem 0rem',
    }
}));

export const CustomButtonText = styled(Typography)(({ theme }) => ({
    fontSize: "inherit",
    fontFamily: theme.fonts.default,
    textAlign: "center",
    textTransform: "none",
    lineHeight: theme.lineHeights.short
}));